module.exports = __webpack_public_path__ + "static/hyperv_34.75a4be17.jpg";